<template>
  <b-form-group
    label="Kode Lokasi"
    label-for="kodeLokasi"
    label-class="pb-0 pt-0"
  >
    <b-form-input
      v-model="kolok"
      disabled
    />
  </b-form-group>
</template>
<script>
export default {
  props: {
    kolok: { type: String, default: '' },
  },
}
</script>
